import { render, staticRenderFns } from "./HorizontalBarChartFeatures.vue?vue&type=template&id=df309bc6&scoped=true&"
import script from "./HorizontalBarChartFeatures.vue?vue&type=script&lang=js&"
export * from "./HorizontalBarChartFeatures.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalBarChartFeatures.vue?vue&type=style&index=0&id=df309bc6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df309bc6",
  null
  
)

export default component.exports